/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { useRef, useCallback, useState } from 'react'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup'
import { AiOutlineMail } from 'react-icons/ai'

import Input from '../../../../components/Input'
import { ILogin } from '../../../../types/login'
import LogoDirecao from '../../../../assets/logos/Direção_2023_Logo_Direção.svg'
import getValidationError from '../../../../utils/getValidationErrors'
import { toast } from 'react-toastify'
import { Container, Wrapper, TextCard, WrapperForm } from './styles'
import history from '../../../../services/history'
import { SEND_EMAIL_FORGOT_PASSWORD } from 'pages/ForgotPassword/services'

const ForgotPasswordPage: React.FC = () => {
  const formRef = useRef<FormHandles>()

  const [loading, setLoading] = useState(false)

  function handleBack() {
    history.push('/')
  }

  const handleSendEmail = useCallback(async (data: ILogin) => {
    try {
      setLoading(true)
      formRef.current?.setErrors({})
      const schema = Yup.object().shape({
        email: Yup.string().required('Informe o seu email'),
      })
      await schema.validate(data, {
        abortEarly: false,
      })

      const response = await SEND_EMAIL_FORGOT_PASSWORD(data.email)

      setLoading(false)

      if (response.status === 401) return
      if (response?.status === 200) {
        toast.success('E-mail enviado com sucesso!')
      } else {
        toast.error('Não foi possível enviar o E-mail, tente novamente mais tarde!')
      }
    } catch (err) {
      setLoading(false)
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationError(err)
        formRef.current?.setErrors(errors)
      }
      if (err.response.data.error === 'Usuário não encontrado') setLoading(false)
      return toast.error('E-mail não cadastrado')
    }
  }, [])
  return (
    <Container>
      <Wrapper>
        <TextCard>
          <div>
            <h1>Bem-vindo à nossa plataforma</h1>
            <h3>
              Direção Concursos representa, na atualidade, o que há de melhor na preparação em alto
              rendimento para concursos públicos no Brasil.
            </h3>
          </div>
        </TextCard>
        <WrapperForm>
          <div className="img-direcao">
            <img src={LogoDirecao} alt="Direção Concursos" />
          </div>
          <Form ref={formRef} onSubmit={handleSendEmail} autoComplete="false">
            <Input name="email" placeholder="E-mail" icon={AiOutlineMail} type="email" />
            <button type="submit" disabled={loading}>
              {loading ? 'Aguarde...' : 'Enviar'}
            </button>
          </Form>
          <p onClick={handleBack}>
            <b>Voltar</b>
          </p>
        </WrapperForm>
      </Wrapper>
    </Container>
  )
}

export default ForgotPasswordPage
